// extracted by mini-css-extract-plugin
export const footer = "style-module--footer--2OS_y";
export const footer__content = "style-module--footer__content--36S5D";
export const footer__copy = "style-module--footer__copy--39Oew";
export const footer__credit = "style-module--footer__credit--EnwGI";